var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { LoginStateScreen } from "healthex-common/device-hint.dtos";
export { LoginStateScreen };
export class DeviceHintManager {
    constructor(deviceHintService, authManager) {
        this.deviceHintService = deviceHintService;
        this.authManager = authManager;
        this.loginState = null;
        this.loginStateLoaded = false;
        this.loadingLoginState = false;
        this.forgettingDevice = false;
        this.loadLoginStateToken = 0;
    }
    async loadLoginState() {
        const requestToken = ++this.loadLoginStateToken;
        this.loadingLoginState = true;
        try {
            const loginState = await this.deviceHintService.getLoginState();
            if (requestToken === this.loadLoginStateToken) {
                this.loginState = loginState;
            }
        }
        catch (e) {
            console.error("Failed to load login state", e);
            if (requestToken === this.loadLoginStateToken) {
                this.loginState = { screen: LoginStateScreen.STANDARD_LOGIN };
            }
        }
        finally {
            if (requestToken === this.loadLoginStateToken) {
                this.loginStateLoaded = true;
                this.loadingLoginState = false;
            }
        }
    }
    async forgetDevice() {
        this.forgettingDevice = true;
        this.loadLoginStateToken++;
        try {
            await this.deviceHintService.forgetDevice();
        }
        catch {
        }
        finally {
            this.loginState = { screen: LoginStateScreen.STANDARD_LOGIN };
            this.loginStateLoaded = true;
            this.loadingLoginState = false;
            this.forgettingDevice = false;
        }
    }
}
__decorate([
    observable
], DeviceHintManager.prototype, "loginState", void 0);
__decorate([
    observable
], DeviceHintManager.prototype, "loginStateLoaded", void 0);
__decorate([
    observable
], DeviceHintManager.prototype, "loadingLoginState", void 0);
__decorate([
    observable
], DeviceHintManager.prototype, "forgettingDevice", void 0);
